<template>
  <div class="yCenter">
    <div v-bind:style="{ width: getWidth('shipDate') }" class="colStyle">
      {{ items.shipDate }}
    </div>
    <div v-bind:style="{ width: getWidth('storage.name') }" class="colStyle">
      {{ items.storage.name }}
    </div>
    <div v-bind:style="{ width: getWidth('userId') }" class="colStyle">
      {{ getUserName(items.user) }}
    </div>
    <div
      v-if="isDisplay('sale.customerId')"
      v-bind:style="{ width: getWidth('sale.customerId') }"
      class="colStyle"
    >
      {{ items.sale.customer.rep }}
    </div>

    <!-- ステータス -->
    <div class="yCenter font-weight-bold" v-if="isOperation">
      <span v-if="isDisplay('status')" class="yCenter operationAreaStyle mr-1">
        <span class="primary--text statusNameStyle mr-1">
          {{ getStatusName(items.status) }}
        </span>
        <NormalButton
          class="btnStyle ml-2 mr-4"
          btnClass="pa-0"
          :text="complete.dialog.status.name"
          height="32px"
          width="70px"
          :disabled="complete.dialog.status.isDisabled"
          @click="onClickComplete(complete.dialog.status.name)"
        />
      </span>
      <CompleteDialog
        v-if="isDisplay('status')"
        v-model="complete.dialog"
        @complete="completeMethod"
        title="ship.ship_arrival-operation"
        :noName="$t('ship.ship_ship')"
        :noValue="items.transaction.controlNumber"
        :dateName="$t('ship.ship_arrival')"
        :buttonName="$t('ship.ship_arrival')"
      />

      <NormalButton
        text="ship.ship_delivery-slip"
        class="ml-5 mr-2"
        btnClass="pa-2"
        height="32px"
        width="15px"
        color="white"
        textColor="thinText--text"
        :outlined="true"
        :disabled="complete.dialog.status.isDisabled"
        @click="onClickLedgerSheetDeliverySlip"
      />

      <NormalButton
        text="ship.ship_ship-adjust"
        height="32px"
        color="white"
        textColor="thinText--text"
        class="mx-2"
        btnClass="pa-2"
        :outlined="true"
        @click="quickFix.dialog.dialog = true"
        :disabled="complete.dialog.status.isDisabled"
      />
      <QuickFixShipDialog
        v-model="quickFix.dialog"
        title="ship.ship_ship-adjust"
        width="80%"
        :recItems="items"
        :pageInfoData="quickFix.pageInfoData"
        @sumit="pageReload"
        :disabled="complete.dialog.status.isDisabled"
      />

      <NormalButton
        v-if="authority.isAdmin"
        text="ship.ship_ship-cancel"
        class="mx-2"
        btnClass="pa-2"
        height="32px"
        width="15px"
        color="white"
        textColor="thinText--text"
        :outlined="true"
        @click="cancel(items.shipId)"
        :disabled="complete.dialog.status.isDisabled"
      />
    </div>
  </div>
</template>
<script>
import {
  countryUtil,
  countryCallingCodeUtil,
  shipUtil,
  commonUtil
} from '@/util'
import { shipStatusHistory } from '@/config'

import NormalButton from '@/components/items/Buttons/NormalButton'

import { CompleteDialog } from '@/components/layouts/Dialogs'
import { QuickFixShipDialog } from '@/components/layouts/Dialogs'

import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    NormalButton,
    CompleteDialog,
    QuickFixShipDialog
  },
  props: {
    headers: { default: [] },
    items: { default: [] },
    isOperation: { default: false }
  },
  data: () => ({
    rowDialogMethodCommonName: 'rowDialogMethodCommon',

    quickFix: {
      dialog: {
        dialog: false
      },
      pageInfoData: {}
    },
    complete: {},
    ship: {
      dialog: {
        dialog: false
      },
      tables: [
        {
          title: { default: '' },
          name: { default: '' },
          items: { default: [] },
          itemKey: { default: '' }
        }
      ]
    },
    payment: {
      dialog: {
        dialog: false
      },
      tables: [
        {
          title: { default: '' },
          name: { default: '' },
          items: { default: [] },
          itemKey: { default: '' }
        }
      ]
    }
  }),
  created() {
    this.ini()
  },
  methods: {
    ...mapActions('Ship', [
      'registerShipComplete',
      'cancelShip',
      'registerShipCompleteCancel'
    ]),
    ini() {
      this.getStatusButtonInfo(this.items.status)

      this.complete.dialog.data.id = this.items.shipId
      this.quickFix.pageInfoData = {
        line1: {
          controlNumber: this.items.transaction.controlNumber,
          customerName: this.items.sale.customer.organizationName,
          storageName: this.items.storage.name,
          shipDate: this.items.shipDate,
          trackingNumber: this.items.trackingNumber,
          remarks: {
            data: this.items.shipNote ? this.items.shipNote.body : '',
            title: '',
            text: ''
          }
        },
        line2: {
          fullName: this.items.destName,
          organizationName: this.items.destOrganizationName,
          phone: {
            // TODO：APIのレスポンスはcodeで良いか
            countryCode: countryCallingCodeUtil.getPhoneNumberInfoById(
              this.items.destPhoneNumberCountryCode
            ),
            phoneNumber: this.items.destPhoneNumber
          },
          country: countryUtil.getCountryIdInfo(this.items.destCountryId),
          postalCode: this.items.destPostalCode,
          // TODO：入力欄を動的にする
          region: countryUtil.getRegionInfo(
            this.items.destCountryId,
            this.items.destRegionId
          ),
          address1: this.items.destAddress1,
          address2: this.items.destAddress2
        }
      }
    },
    getWidth(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? obj.width : '100px'
    },
    getUserName(user) {
      return user ? user.lastName + user.firstName : '-'
    },
    getStatusName(status) {
      return shipUtil.getShipArrivalStatusName(status)
    },
    getStatusButtonInfo(status) {
      let statusInfo
      const statusList = shipStatusHistory.ARRIVAL_STATUS
      switch (status) {
        case statusList.BEFORE_ARRIVAL:
          statusInfo = {
            name: 'ship.ship_arrival',
            isDisabled: false
          }
          break
        case statusList.AFTER_ARRIVAL:
          statusInfo = {
            name: 'ship.ship_arrival-cancellation',
            isDisabled: false
          }
          break
        case statusList.CANCEL:
          statusInfo = {
            name: 'order.order_invalid',
            isDisabled: true
          }
          break
        default:
          statusInfo = {
            name: '-',
            isDisabled: true
          }
          break
      }

      this.complete = {
        dialog: {
          dialog: false,
          data: {
            id: '',
            date: commonUtil.getToday()
          },
          status: statusInfo
        }
      }
    },
    isDisplay(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? true : false
    },
    async completeMethod() {
      const isSucceed = await this.registerShipComplete(
        this.complete.dialog.data
      )
      if (isSucceed) {
        this.complete.dialog.dialog = false
        this.pageReload()
      }
    },
    async onClickComplete(statusName) {
      // 到着状態の場合
      if (statusName === 'ship.ship_arrival') {
        this.complete.dialog.dialog = true
        return
      }
      if (!confirm(this.$t('stock-move.stock-move_arrival-cancel-check')))
        return
      const isSuccess = await this.registerShipCompleteCancel({
        id: this.items.shipId
      })
      if (isSuccess) alert(this.$t('order.order_canceled'))

      this.pageReload()
    },
    pageReload() {
      this.$emit(this.rowDialogMethodCommonName, 'reload')
    },
    async cancel(shipId) {
      const isConfirmed = confirm(this.$t('ship.ship_restore-order-question'))

      if (isConfirmed) {
        const isSucceed = await this.cancelShip({ id: shipId })
        if (isSucceed) {
          alert(this.$t('common.common_canceled-alert'))
          this.$emit('dialogReload')
          this.pageReload()
        }
      }
    },
    onClickLedgerSheetDeliverySlip() {
      this.$emit('onClickLedgerSheet', 'deliverySlip', this.items)
    }
  },
  watch: {
    items: {
      deep: true,
      handler(newVal) {
        this.ini()
      }
    }
  },

  computed: {
    ...mapGetters('User', ['authority'])
  }
}
</script>
<style lang="scss" scoped>
.colStyle {
  word-wrap: break-word;
}
.btnStyle {
  max-width: 105px;
  padding: 0px !important;
}
.statusNameStyle {
  width: 50px;
}
.operationAreaStyle {
  width: 120px;
}
</style>
